import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useLocation, MESSAGES } from './../../common/helper/common-imports.component.js';
import{  RowsPerPageSelector, SearchTable, DataTable } from './../../common/helper/table-imports.js';
import ExpandedComponent from "./row-expand.component.js";
import Confirmation from '../../common/modals/confirmation.component.js';
import UserService from "./../../../services/user-service.js";
import { usersColumns } from './users-col.component.js'
import  useNavigation from '../../../hooks/useNavigation.js'
import { getConditionalRowStyles,customExpandableIcon, customDataTableStyles } from '../../common/helper/data-table.styles.js';

const Users = () => { 
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const conditionalRowStyles = getConditionalRowStyles(expanded);
  const { navigateTo } = useNavigation();

  const [row, setRow] =  useState({});
  const [modalShow, setModalShow] = React.useState(false);

  const [users, setUsers] = useState([]);
  
  const resumeUser = (resume) => {
    setLoading(true);
    UserService.resumeUser(resume)
      .then(response => {
        toast.success(MESSAGES.USR_RESUME);
        getUserList();
        setLoading(false);
        setModalShow(false);
        setSelectedRows([])
        setDataTableKey((prevKey) => prevKey + 1);

      })
      .catch(error => {
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error(MESSAGES.SERVER_ERROR)
        }

        setLoading(false);
      });
  }
 
  const changeStatus = (row) => {
    setModalShow(true)
    setRow({
      user_id: row.user_id,
      status: row.status,
      modalId: 'statusChangeUser'
    })
  }

  const deleteConfirmation = () => {
    setLoading(true);
    UserService.deleteUser(row.user_id)
    .then(response => {
      toast.success(MESSAGES.USR_DELETED);
      getUserList();
      setLoading(false);
      setModalShow(false)
    })
    .catch(error => {
      const errorMessage = error.response.data
      toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      setLoading(false);
     
    });
   }
   const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey(prevKey => prevKey + 1);
  };

  const updateStatus = () => {

    if(row.modalId == 'statusChangeUser') {
     const suspended = [];
     const resume = [];
     if(row.status.toLowerCase() == 'active'){
       suspended.push(row.user_id);
       suspendUser(suspended)
     }else{
       resume.push(row.user_id);
       resumeUser(resume)
     }
    } else if (row.modalId == 'statusChangeUserSuspend') {
      const suspended = [];
      for(var i=0; i<selectedRows.length > 0; i++) {
        if(selectedRows[i].status_id.toLowerCase() == 'a'){
          suspended.push(selectedRows[i].user_id);
        }
        
      }
      suspendUser(suspended)

    }else if (row.modalId == 'statusChangeUserResume') {
      const resume = [];
      for(var i=0; i<selectedRows.length > 0; i++) {
        if(selectedRows[i].status_id.toLowerCase() == 's'){
          resume.push(selectedRows[i].user_id);
        }
      }
      resumeUser(resume)
    }
    
    
    else {
     deleteConfirmation()
    }
    
   }
   const suspendUser= (suspended) => {
    setLoading(true);
    UserService.suspendUser(suspended)
      .then(response => {
        toast.success(MESSAGES.USR_SUSPENDED);
        getUserList();
        setLoading(false);
        setModalShow(false)
        setSelectedRows([])
        setDataTableKey((prevKey) => prevKey + 1);

      })
      .catch(error => {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        setLoading(false);
       
      });
 
  }

  const deleteUser = (row) => {
    setModalShow(true)
    setRow({
      user_id: row.user_id,
      status: row.status,
      modalId: 'deleteUser'
    })
  }




  const getUserList = (e) => {
    setLoading(true);
    UserService.getUsers()
    .then((response) => {
      setUsers(response.data.data);
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
    });
   
  }
  useEffect(() => {
    getUserList();
    document.body.style.backgroundImage = '';
    document.body.style.backgroundColor = '#f0f6fa';
    
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);
  const navigate = useNavigate();

  const handleRowExpand = (row, data) => {
    const newExpanded = { ...expanded };
    newExpanded[data.user_id] = !expanded[data.user_id];
    setExpanded(newExpanded);
  };
  

const paginationComponentOptions = { 
  noRowsPerPage :true
}
const handleSearchChange = (e) => {
  setSearchTerm(e.target.value);
};

const escapeRegExp = (string) => {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
const filteredData = users.filter((row) =>
Object.values(row).some(
  (value) =>
    new RegExp(escapeRegExp(searchTerm), 'i').test(value)
)
  );


const resetSearch = () => {
  setSearchTerm('');
}

const selectRows =  React.useCallback(state => {
    setSelectedRows(state.selectedRows);
}, []);

const suspendMultiple = () => {
  setModalShow(true)
  setRow({
   // user_id: row.user_id,
    status: 'Suspend',
    modalId: 'statusChangeUserSuspend'
  })
}

const resumeMultiple = () => {
  setModalShow(true)
  setRow({
   // user_id: row.user_id,
    status: 'Resume',
    modalId: 'statusChangeUserResume'
  })
}

const [columns, setColumns] = useState(usersColumns(expanded,changeStatus, deleteUser));


useEffect(() => {
  if (filteredData?.length) {
    const element = document.getElementsByClassName("sc-bHCmUC");
    const childElement =element[0].children
    for (let i = 0; i < childElement?.length; i++) {
      const ele = childElement[i].id.split("-")[1];
      if (Number(ele) % 2 === 0)  {
        childElement[i].classList.add("odd-transaction-table");
      } else {
        childElement[i].classList.add("even-transaction-table");
      }
    }
  }
}, [filteredData])

  return (
    <div>
            <LoaderOverlay loading={loading} />

    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
                    <div className="container" style={{backgroundColor: 'white'}}>
                      <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist" >
                          <button className="nav-link active tbbtn" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" onClick={resetSearch}>User Managment List</button>
                          
                        </div>
                      </nav>
    
                      <div className="filterBtn">
                        
                        <div id="examplemgm_filter" className="dataTables_filter"><label><input type="search" className placeholder="Search..."  value={searchTerm}
                        onChange={handleSearchChange} aria-controls="examplemgm" /></label></div>
                        <div onClick={() => navigateTo('add','add-user')} className="dt-buttons ui-buttonset"><a className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg" tabIndex={0} aria-controls="examplemgmuser"><span className="ui-button-text">Add User</span></a></div>
                  </div>

                  <RowsPerPageSelector rowsPerPage={rowsPerPage} onRowsPerPageChange={handleRowsPerPageChange} />
                      <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
                        <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" style={{position: 'relative'}}>

                        <div className="multi">
                          <a className="nav-link dropdown-toggle news fell jhb" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ opacity: selectedRows.length > 0 ? 1 : '', pointerEvents: selectedRows.length > 0 ? 'auto' : 'none'  }}>
                          <i className="fa fa-ellipsis-h" aria-hidden="true"  />

                          </a>
                          <ul className="dropdown-menu dropdown-menu-end mbv" id="nvb" aria-labelledby="navbarDropdown" style={{}}>
               
                            <li onClick={suspendMultiple}>
                              <a className="dropdown-item" href="#!" style={{fontSize: '13px'}}>Suspend</a>
                            </li>
                            <li  onClick={resumeMultiple}>
                              <a className="dropdown-item" href="#!" style={{fontSize: '13px'}}>Activate</a>
                            </li>
                          </ul>
                          <span className="DataTables_sort_icon css_right ui-icon ui-icon-triangle-1-n" /></div>

                        <DataTable key={dataTableKey}
                        className="userManagment"
                            columns={columns}
                              data={filteredData}
                              pagination
                              // selectableRows
                              // expandableRows
                              // expandableRowsComponent={ExpandedComponent}
                              // onRowExpandToggled={handleRowExpand}
                              paginationComponentOptions={paginationComponentOptions} 
                              conditionalRowStyles={conditionalRowStyles}
                              paginationPerPage={rowsPerPage} 
                              // expandableIcon={customExpandableIcon}
                              // expandOnRowClicked = {true}
                onSelectedRowsChange={selectRows}
                customStyles={customDataTableStyles}
                        />
                        </div>

                      </div>
                    </div>
                  </div>
                  <Confirmation  show={modalShow} onHide={() => setModalShow(false)} onSave={() => updateStatus(false)} status={row.status} modalId = {row.modalId}></Confirmation>
                 
                  </div>
               

)

}
function mapStateToProps(state) {
   const userData = state.authReducer.user;
   return { userData };
 }
 export default withAuth(connect(mapStateToProps)(Users));
